import type { RetailerOrderSummary } from '../../api/types';

/**
 * "FedEx · 1Z999" — what the Shipment / tracking cell says for one shipment.
 * A shipment with no carrier and no tracking number yet is still named by its
 * own reference, so the cell is never blank while something has been booked.
 */
export function shipmentLine(s: RetailerOrderSummary['shipments'][number]): { title: string; detail: string | null } {
  const detail = [s.carrier, s.trackingReference].filter(Boolean).join(' · ');
  return { title: s.reference, detail: detail || null };
}

/** A filename-safe name for a downloaded invoice when the server did not send one. */
export function invoiceFileName(reference: string): string {
  return `${reference.replace(/[^A-Za-z0-9_-]/g, '_')}.pdf`;
}
